import HttpService from '@/services/http/http.service';
import { SystemMetricsViewModel, SystemMetricsHistoryViewModel } from '@/types/apiServerContract';

const API_PATH = 'system/';

export class SystemApi {
    public static async GetSystemMetrics(): Promise<SystemMetricsViewModel> {
        return HttpService.Get<SystemMetricsViewModel>(API_PATH + 'GetSystemMetrics');
    }

    public static async GetSystemMetricsHistory(from: Date): Promise<SystemMetricsHistoryViewModel> {
        return HttpService.Get<SystemMetricsHistoryViewModel>(API_PATH + 'GetSystemMetricsHistory', {
            from
        });
    }
}
